import type { UseQueryOptions } from '@tanstack/react-query'

import type { PolicyDto } from '../api/policy.dto'
import { policy } from '../api/policy.api'
import { POLICY_QUERY_KEYS } from './policy.query-keys'

export type GetPolicyQueryOptions<TSelected = PolicyDto> = Pick<
  UseQueryOptions<PolicyDto, Error, TSelected>,
  'select' | 'enabled' | 'staleTime' | 'gcTime' | 'retry'
> & {
  // EMS-10557: target one enrollment period; omit for the default period
  oepId?: string
}

export function createGetPolicyQueryOptions<TSelected = PolicyDto>(
  customerId: string,
  options?: GetPolicyQueryOptions<TSelected>
): UseQueryOptions<PolicyDto, Error, TSelected> {
  const hasCustomerId = customerId.length > 0
  const { oepId, ...queryOptions } = options ?? {}

  return {
    queryKey: POLICY_QUERY_KEYS.detail(customerId, oepId),
    queryFn: () => policy.get(customerId, oepId),
    ...queryOptions,
    enabled: hasCustomerId && (queryOptions.enabled ?? true),
  }
}
